import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
import { useLocation, useNavigate } from 'react-router-dom'

//components
import Verification from '../../components/signin/Verification'
import PasswordComp from '../../components/signin/Password'
// globals
import * as constants from '../../globals/constants'
import * as TYPE from '../../globals/type'
// images
import Logo from '../../assets/image/logo/ic-logo-ho.svg'
// utils
import { useAxios } from '../../utils/useAxios'
import colors from '../../styles/colors'

export default function ChangePassword() {
  //기존: ResetPassword
  const location = useLocation()

  const [userId, setUserId] = useState(
    location?.state?.selectedUserId ? location?.state?.selectedUserId : '',
  )
  const [name, setName] = useState('')
  const [phoneNum, setPhoneNum] = useState('')
  const [minutes, setMinutes] = useState(undefined)
  const [seconds, setSeconds] = useState(undefined)
  const [clientMsg, setClientMsg] = useState('')
  const [isVerification, setIsVerification] = useState(false)
  const [isChangePwd, setIsChangePwd] = useState(false)
  const [newPassword, setNewPassword] = useState('')
  const [newPassword2, setNewPassword2] = useState('')
  const [pwdClientMsg, setPwdClientMsg] = useState('')
  const [verificationCode, setVerificationCode] = useState('')
  const [certificationCode, setCertificationCode] = useState()
  const [certificationId, setCertificationId] = useState()

  const navigate = useNavigate()
  const { fetchData, loading, data, error } = useAxios()

  const leftText = '아이디 찾기'
  const rightText = '비밀번호 초기화'
  const isLeftAlign = false

  const handleVerificationResponse = (response, error) => {
    if (response?.responseCode == TYPE.API_RESPONSE.SUCCESS) {
      setIsChangePwd(true)
    }
  }

  // 비밀번호 초기화  인증번호 발송
  const requestVerification = () => {
    if (userId == '') {
      setClientMsg('아이디를 입력해주세요.')
      return false
    }
    if (name == '') {
      setClientMsg('이름을 입력해주세요.')
      return false
    }
    if (phoneNum == '') {
      setClientMsg('휴대전화번호를 입력해주세요.')
      return false
    }
    const requestBody = {
      loginId: userId,
      userName: name,
      userMobile: phoneNum,
    }

    // 로그인 비밀번호 초기화 인증번호 발송
    fetchData(
      constants.API.CHANGE_PWD_CERTIFICATION, // url 기존: RESET_PWD_CERTIFICATION
      'POST', // method
      requestBody, // data
      null,
    )
  }

  // 비밀번호 초기화
  const changePasswordAPI = () => {
    const requestBody = {
      loginId: userId,
      newPassword: newPassword,
      certificationCode: certificationCode,
    }

    fetchData(
      constants.API.CHANGE_PASSSWORD,
      'PATCH', // method
      requestBody, // data
    )
  }

  // api결과 [data]
  useEffect(() => {
    if (data) {
      switch (data.responseCode) {
        case TYPE.API_RESPONSE.SUCCESS: // 성공
          //비밀번호 초기화 성공
          if (data.responseData?.responseCode == TYPE.API_RESPONSE.SUCCESS) {
            navigate('/signin')
            return
          }
          setCertificationCode(data.responseData.certificationCode)
          setVerificationCode(data.responseData.certificationCode)
          setCertificationId(data.responseData.certificationId)
          setIsVerification(true)
          setClientMsg('')
          setMinutes(5)
          setSeconds(0)
          return

        case TYPE.API_RESPONSE.MEMBER_9992: // 계정을 찾을 수 없습니다.
          setClientMsg('계정을 찾을 수 없습니다.')
          // setClientMsg('')
          // alert('계정을 찾을 수 없습니다.')
          return

        case TYPE.API_RESPONSE.MEMBER_9993: // 해지된 사용자
          setClientMsg('')
          alert('해지된 사용자입니다.')
          return

        case TYPE.API_RESPONSE.MEMBER_9994: // 등록된 연락처 정보가 없습니다.
          setClientMsg('')
          alert('등록된 연락처 정보가 없습니다.')
          return

        default:
          setClientMsg('')
      }
    }
  }, [data])

  // 에러 처리
  useEffect(() => {
    if (error) {
      // console.log('error resetpassword-' + error)
      if (error?.resultCode == TYPE.API_RESPONSE.BAD_REQUEST) {
        setClientMsg('입력한 정보를 확인해주세요.')
      }
    }
  }, [error])

  const handleUserIdChange = (e) => {
    const regex = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣!@#$%^&*()_+]/
    if (regex.test(e.target.value)) {
      return
    }
    setUserId(e.target.value)
  }
  return (
    <Container>
      <Wrapper>
        <ContentWrapper>
          <img src={Logo} onClick={() => navigate('/signin')} />
          <TitleTextWrapper>
            <TitleText>해피오더 사장님</TitleText>
          </TitleTextWrapper>
          <TabContainer isLeftAlign={isLeftAlign}>
            <SelectWrapper>
              <AllAnswerWrapper onClick={() => navigate('/findId')}>
                {leftText}
              </AllAnswerWrapper>
              <DivideLine />
              <UnAnswerWrapper isActive="0">{rightText}</UnAnswerWrapper>
            </SelectWrapper>
          </TabContainer>
          {!isChangePwd ? (
            <>
              <Input
                type="text"
                placeholder="아이디"
                value={userId}
                onChange={handleUserIdChange}
              />

              <Input
                type="text"
                placeholder="이름"
                value={name}
                onChange={(e) => {
                  const newValue = e.target.value.replace(
                    /[\d!@#$%^&*()_+]/g,
                    '',
                  )
                  setName(newValue)
                }}
              />
              <Input
                type="tel"
                placeholder={`휴대전화번호 ( "-"는 제외하고 숫자만 입력하세요.)`}
                value={phoneNum}
                onChange={(e) => {
                  const newValue = e.target.value.replace(/[^0-9]/g, '')
                  setPhoneNum(newValue)
                }}
              />
            </>
          ) : (
            ''
          )}
          {isChangePwd ? (
            <>
              <PasswordComp
                setNewPassword={setNewPassword}
                setNewPassword2={setNewPassword2}
                newPassword={newPassword}
                newPassword2={newPassword2}
                resetReason={'updatePwd'}
                updatePasswordAPI={changePasswordAPI}
                pwdClientMsg={pwdClientMsg}
                setPwdClientMsg={setPwdClientMsg}
              />
            </>
          ) : (
            <>
              <ClientMsgWrapper>{clientMsg}</ClientMsgWrapper>
              {isVerification ? (
                <VerificationWrapper>
                  <Verification
                    minutes={minutes}
                    seconds={seconds}
                    setSeconds={setSeconds}
                    setMinutes={setMinutes}
                    onResponse={handleVerificationResponse}
                    changePassword={true}
                    requestVerificationResetPwd={requestVerification}
                    changePwdUserId={userId}
                    certificationCode={certificationCode}
                    setCertificationCode={setCertificationCode}
                    verificationCode={verificationCode}
                    setVerificationCode={setVerificationCode}
                    name={name}
                    phoneNum={phoneNum}
                    certificationId={certificationId}
                    setCertificationId={setCertificationId}
                  />
                </VerificationWrapper>
              ) : (
                <BtnWrap>
                  <CancleButton
                    type="button"
                    onClick={() => navigate('/signin')}
                  >
                    취소
                  </CancleButton>
                  <ResendVerfButton
                    type="button"
                    onClick={() => requestVerification()}
                  >
                    인증번호 요청
                  </ResendVerfButton>
                </BtnWrap>
              )}
            </>
          )}
          <TradeMarkWrapper>
            <TradeMarkText>
              Copyright ⓒ by SPC ALL RIGHTS RESERVED.
            </TradeMarkText>
          </TradeMarkWrapper>
        </ContentWrapper>
      </Wrapper>
    </Container>
  )
}
const ContentWrapper = styled.div`
  position: relative;
  width: 100%;
`
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  margin: auto;
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    display: none;
  }
`
const ClientMsgWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  text-align: left;
  color: #d90000;
  padding: 5px 10px 15px;
  @media ${(props) => props.theme.tablet} {
    padding: 5px 0px 15px;
  }
`
const Wrapper = styled.div`
  img {
    width: 129.3px;
    height: 50px;
    cursor: pointer;
  }
  width: 430px;
  height: 813px;
  border-radius: 15px;
  box-shadow: 0 3px 12px 0 rgba(102, 102, 102, 0.1);
  background-color: #fff;
  padding: 50px 30px 30px;
  display: flex;
  justify-content: center;
  color: #8a8a8a;
  text-align: center;
  @media ${(props) => props.theme.mobile} {
    width: 360px;
    height: 760px;
    box-shadow: none;
  }
`
const TitleTextWrapper = styled.div`
  margin: 15px 0px 25px;
  @media ${(props) => props.theme.mobile} {
  }
`
const TitleText = styled.span`
  font-size: 25px;
  font-weight: bold;
  text-align: center;
  color: #00402e;
  @media ${(props) => props.theme.mobile} {
  }
`
const Input = styled.input`
  font-size: 14px;
  text-align: left;
  color: #a8a8a8;
  width: 360px;
  height: 50px;
  border-radius: 8px;
  border: solid 1px #e5e5e5;
  background-color: #fff;
  color: #8a8a8a;
  box-shadow: none !important;
  padding: 10px;
  margin-bottom: 10px;
  &:focus {
    outline: none !important;
  }
  @media ${(props) => props.theme.mobile} {
    width: 300px;
  }
`
const VerificationWrapper = styled.div`
  padding-top: 40px;
  @media ${(props) => props.theme.tablet} {
    padding-top: 60px;
  }
  @media ${(props) => props.theme.mobile} {
    padding-top: 90px;
  }
`
const Button = styled.div`
  position: absolute;
  bottom: 10%;
  width: 100%;
  height: 50px;
  border-radius: 8px;
  background-color: #00a61c;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: #fff;
  @media ${(props) => props.theme.mobile} {
    width: 300px;
  }
`

const BtnWrap = styled.div`
  position: absolute;
  bottom: 10%;
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 12px;
`

const ResendVerfButton = styled.button`
  width: 100%;
  border-radius: 8px;
  background-color: #00a61c;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: #fff;
  border: none;
  @media ${(props) => props.theme.mobile} {
    width: 300px;
  }
`

const CancleButton = styled.button`
  width: 100%;
  border-radius: 8px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: #000;
  border: solid 1px #e5e5e5;
  @media ${(props) => props.theme.mobile} {
    width: 300px;
  }
`

const RulesTxt = styled.div`
  font-size: 14px;
  text-align: left;
  color: #8a8a8a;
  width: 360px;
  margin: auto;
  @media ${(props) => props.theme.mobile} {
    width: 300px;
  }
`
const TradeMarkWrapper = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  @media ${(props) => props.theme.mobile} {
  }
`

const TradeMarkText = styled.span`
  font-size: 12px;
  color: #a8a8a8;
  @media ${(props) => props.theme.mobile} {
  }
`
const TabContainer = styled.div`
  width: ${(props) => props.isLeftAlign && '100%'};
  display: flex;
  flex-direction: row;
  margin: 50px 0px 35px;
  @media ${(props) => props.theme.mobile} {
    width: 300px;
    margin: auto;
    margin-bottom: 35px;
    margin-top: 50px;
  }
`
const SelectWrapper = styled.div`
  display: flex;
  flex-direction: row;
  /* width: 360px; */
  width: 100%;
  height: 50px;
  cursor: pointer;
`
const AllAnswerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  border: solid 1px #e5e5e5;
  background-color: #fff;
  font-size: 16px;
  font-weight: bold;
  color: #a8a8a8;
  &:hover {
    color: ${colors.W1};
    border-top: 1px solid ${colors.mainG};
    border-bottom: 1px solid ${colors.mainG};
    border-right: 1px solid ${colors.mainG};
    background-color: ${colors.mainG};
  }
  @media ${(props) => props.theme.mobile} {
    font-size: 14px;
  }
`
const DivideLine = styled.div`
  width: 1px;
  background-color: ${colors.mainG};
`
const UnAnswerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  background-color: #fff;
  background-color: ${colors.mainG};
  font-weight: bold;
  font-size: 16px;
  color: ${colors.W1};
  &:hover {
    color: ${colors.W1};
    border-left: 1px solid ${colors.mainG};
    border-top: 1px solid ${colors.mainG};
    border-bottom: 1px solid ${colors.mainG};
    background-color: ${colors.mainG};
  }
  @media ${(props) => props.theme.mobile} {
    font-size: 14px;
  }
`
